import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {Constants} from "../constants/Constants";
import AppColors from "../colors/AppColors";
import React from "react";
import '../input.css'

const StakeAmountField = React.forwardRef(function (props: any, ref: any) {

    const costPerTicket = useSelector((state: RootStateOrAny) => state.appReducer[Constants.COST_PER_TICKET]);
    const dispatch = useDispatch();

    const handleStakeAmountChanged = (newValue: string | null) => {
        let stakeAmountValue = newValue;
        if (parseFloat(stakeAmountValue as string) > Constants.MAX_ALLOWED_BET_AMOUNT) {
            stakeAmountValue = '' + Constants.MAX_ALLOWED_BET_AMOUNT;
        }
        dispatch({
            type: Constants.UPDATE_COST_PER_TICKET,
            payload: {
                [Constants.COST_PER_TICKET]: stakeAmountValue
            }
        });
    }
    return <input
        style={{
            paddingTop: 10,
            color: 'white',
            paddingBottom: 10,
            fontStyle: 'bold',
            fontWeight: 600,
            fontSize: 30,
            textAlign: 'center',
            backgroundColor: AppColors.CARD_BACKGROUND_COLOR
        }}
        ref={ref}
        value={costPerTicket}
        type={"text"}
        onChange={(event) => {
            handleStakeAmountChanged(event.target.value)
        }}/>
});
export default StakeAmountField;